import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { loginService } from "../services/loginService";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();

const handleLogin = async () => {
  setLoading(true);
  setError("");
  try {
    const res = await loginService({ email, password });
    console.log("✅ Login success:", res);

    // Save token in cookies (secu>re)
    Cookies.set("jwt", res.token, { path: "/" });

    // 🔍 Debug log to confirm token is saved
    console.log("🔑 Saved JWT Token:", Cookies.get("jwt"));

    // Show success toast
    toast.current?.show({
      severity: "success",
      summary: "Login Successful",
      detail: "Redirecting to dashboard...",
      life: 1000,
    });

  // Redirect after short delay
setTimeout(() => {
  console.log("➡️ Redirecting to /dashboard with token:", Cookies.get("jwt"));
  navigate("/dashboard");
}, 2000);
  } catch (err: any) {
    setError(err.response?.data?.message || "Login failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
  <Toast ref={toast} />
  <div className="bg-white shadow-lg rounded-xl p-8 w-96">
    <h2 className="text-2xl font-semibold text-center mb-6">Login</h2>

    <div className="mb-4">
      <label className="block mb-2">Email</label>
      <InputText
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full"
        placeholder="Enter your email"
      />
    </div>

    <div className="mb-4">
      <label className="block mb-2">Password</label>
      <Password
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        feedback={false}
        toggleMask
        className="w-full"
        placeholder="Enter your password"
      />
    </div>

    {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

    <Button
      label={loading ? "Logging in..." : "Login"}
      icon="pi pi-sign-in"
      className="w-full btn"
      onClick={handleLogin}
      disabled={loading}
    />

    {/* Forgot Password Link */}
    <div className="text-center mt-4">
      <a
        href="/forgot-password"
        className="text-sm text-blue-500 hover:text-blue-700 transition-colors"
      >
        Forgot Password?
      </a>
    </div>
  </div>
</div>

  );
};

export default LoginPage;
